import PropTypes from 'prop-types';
import useLabels from 'infrastructure/js/hooks/useLabels';
import MobileHeader from '../Common/MobileHeader/mobileHeader';
import FullScreenToggle from 'infrastructure/js/components/FullScreenToggle/fullScreenToggle';

require('./mainPage.scss');

export default function MainPage ( {
                                     history,
                                   }) {

  const pageLabels = useLabels('mat.mobile.mainPage.');

  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'labelButton',
          label: pageLabels.get('header.title')
        },
        {
          id: 'fullScreenButton',
          className: 'divider-left',
          buttonComponent: FullScreenToggle
        },
      ]
    };
  }

  const getMenuItems = () => {
    return [
      {
        id: 'moveAssetBtn',
        label: pageLabels.get('buttons.button.moveAssets'),
        path: '/MoveAssets',
      },
      {
        id: 'attachTagBtn',
        label: pageLabels.get('buttons.button.attachTag'),
        path: '/ScanTool',
      },
      {
        id: 'reportProgressBtn',
        label: pageLabels.get('buttons.button.reportProgress'),
        path: '/scanWorkOrder',
      },
    ];
  }


  const createMenuItems = () => {
    return getMenuItems().map((item, index) => {
      return (
        <div id={item.id} key={index}
             className="border-btn main-menu-item"
             onClick={() => {history?.push(item?.path)}} >
          {item.label ?? ''}
        </div>
      );
    });
  };

  return (
    <div className="main-page">
      <MobileHeader {...getHeaderItems()} />
      <div className="main-menu">{createMenuItems()}</div>
    </div>
  );
}

MainPage.propTypes = {
  history: PropTypes.object,
};

